'use strict';
import $ from 'jquery';

export default class M72 {
    static init() {
        $('.module-m72').each((index, el) => {
            new M72($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        const self = this;
        // console.log("got here");
        if(this.el.find('.wistia-video-frame').length > 0) {
            const video_id = this.el.find('.wistia-video-frame').data('wistia-video-id');
            window._wq = window._wq || [];
            _wq.push({ 
                id: video_id, 
                onReady: function(video) {
                    self.el.addClass('wistia-processed');
                    self.video = video;
                    self.onResize();
                    $(window).on('resize', self.onResize.bind(self));
                    self.el.find('.wistia-video-frame').css('right', 'unset');
                }
            });
        }

    }
     
    onResize() {
        if($(window).width() > 767) {
            const videoRatio = this.video.videoWidth() / this.video.videoHeight();
            const elRatio = this.el.outerWidth() / this.el.outerHeight();
            // console.log("video ratio: %f, el ratio: %f", videoRatio, elRatio);
            if(elRatio < videoRatio) {
                // console.log("using height");
                const ratio = this.el.outerHeight() / this.video.videoHeight();
                // const ratio = this.el.outerWidth() / this.video.videoWidth();
                // console.log("ratio: ", ratio);
                const newWidth = this.video.videoWidth() * ratio;
                this.el.find('.wistia-video-frame').css('width', (newWidth) + 'px');
                this.el.find('.wistia_responsive_wrapper').css('left', ($(window).width() - newWidth + 10) + 'px');
                // console.log("using %d", ($(window).width() - newWidth));
            } else {
                // console.log("using width");
                const ratio = this.el.outerWidth() / this.video.videoWidth();
                // console.log("ratio: ", ratio);
                this.el.find('.wistia-video-frame').css('width', (this.video.videoWidth() * ratio) + 'px');
                this.el.find('.wistia_responsive_wrapper').css('left', '10px');
            }
        }
    }
}